module.exports = __webpack_public_path__ + "static/bus_traslado1-950d13ea7ffcbdd2c4cd9f98d8860003.jpg";